"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactHelmet = require("react-helmet");

var _PageLoadingSpinner = _interopRequireDefault(require("@jobmatchme/ui/es/components/PageLoadingSpinner"));

var _ThemeProvider = _interopRequireDefault(require("@jobmatchme/ui/es/provider/ThemeProvider"));

var _External = require("@jobmatchme/routing/es/provider/External");

var _Button = _interopRequireDefault(require("@jobmatchme/ui/es/components/Button"));

var _Link = _interopRequireDefault(require("@jobmatchme/ui/es/components/Link"));

var _Container = _interopRequireDefault(require("@material-ui/core/Container"));

var _SectionKeyVisual = _interopRequireDefault(require("../SectionKeyVisual"));

var _reactI18next = require("react-i18next");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var PageHeader = /*#__PURE__*/(0, _react.lazy)(function () {
  return import(
  /* webpackChunkName: 'bcpageheader' */
  '../../common/CleanHeader');
});
var SectionHow = /*#__PURE__*/(0, _react.lazy)(function () {
  return import(
  /* webpackChunkName: 'bcsechow' */
  '../SectionHow');
});
var SectionCallToAction = /*#__PURE__*/(0, _react.lazy)(function () {
  return import(
  /* webpackChunkName: 'pcseccta' */
  '../SectionCallToAction');
});
var SectionMap = /*#__PURE__*/(0, _react.lazy)(function () {
  return import(
  /* webpackChunkName: 'pcsecmap' */
  '../SectionMap');
});
var SectionWhy = /*#__PURE__*/(0, _react.lazy)(function () {
  return import(
  /* webpackChunkName: 'pcsecwhy' */
  '../SectionWhy');
});
var Footer = /*#__PURE__*/(0, _react.lazy)(function () {
  return import(
  /* webpackChunkName: 'pcsecfooter' */
  '../../../truck/common/Footer');
});

var DriverPage = function DriverPage(_ref) {
  var applicationRoutes = _ref.applicationRoutes;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var translateNs = 'landingpage-components:driverPage'; // Its used for Adwords Compaigns

  var getUtmParams = function getUtmParams() {
    var queryString = window && window.location.search;
    localStorage.setItem('utmStrings', queryString);
  };

  (0, _react.useEffect)(function () {
    return getUtmParams();
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react.default.createElement("title", null, t("".concat(translateNs, ".meta.title"))), /*#__PURE__*/_react.default.createElement("meta", {
    name: "description",
    content: t("".concat(translateNs, ".meta.description"))
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "keywords",
    content: t("".concat(translateNs, ".meta.keywords"))
  })), /*#__PURE__*/_react.default.createElement(_ThemeProvider.default, {
    variant: "pc"
  }, /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement("div", null)
  }, /*#__PURE__*/_react.default.createElement(PageHeader, {
    variant: 'pc',
    pcLogin: true,
    bcLink: /*#__PURE__*/_react.default.createElement(_Link.default, {
      to: 'https://jobmatch.me/de-de/arbeitgeber/lkw-fahrer-finden/',
      id: "arbeitgeber"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      variant: "outlined",
      size: "small",
      color: "white"
    }, t("".concat(translateNs, ".gkButton"))))
  })), /*#__PURE__*/_react.default.createElement("div", {
    itemScope: "itemscope",
    itemType: "http://schema.org/WebPage",
    style: {
      marginRight: '-1px'
    }
  }, /*#__PURE__*/_react.default.createElement(_SectionKeyVisual.default, null), /*#__PURE__*/_react.default.createElement(_Container.default, {
    noPadding: true,
    style: {
      padding: '0px',
      width: '100%',
      overflowX: 'hidden'
    }
  }, /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement("div", null)
  }, /*#__PURE__*/_react.default.createElement(SectionHow, null)), /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement("div", null)
  }, /*#__PURE__*/_react.default.createElement(SectionCallToAction, null)), /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement("div", null)
  }, /*#__PURE__*/_react.default.createElement(SectionMap, null)), /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement("div", null)
  }, /*#__PURE__*/_react.default.createElement(SectionWhy, null))), /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_PageLoadingSpinner.default, {
      fullHeight: true
    })
  }, /*#__PURE__*/_react.default.createElement(Footer, null)))));
};

var _default = /*#__PURE__*/_react.default.memo((0, _External.withRoutes)(DriverPage));

exports.default = _default;